<div class="container-fluid">
  <div class="row">
    <div class="col-md-9">
      <div class="my-account">
        <div class="dashboard">
          <div class="box-account">
            <div class="page-title">
              <h5>{{'sidebar.change_pfp' | translate}}</h5>
            </div>
          </div>
        </div>
        <br>
        <div class="col2-set">
          <p style="height: 30px; text-align: center" *ngIf="loading; else formProfilePicture">
            {{'common.loading' | translate}} ...
          </p>
          <ng-template #formProfilePicture>
            <div class="panel panel-default">
              <div class="panel-heading"><h2> </h2></div>
              <div class="panel-body">

                <ng-container *ngIf="isBrowser; else ssrPlaceholder">

                  <!-- Show current picture + file input when no file selected -->
                  <div *ngIf="!selectedFile" class="profile-picture-section">
                    <div class="current-picture-container">
                      <img [src]="profileImage"
                           class="current-profile-image"
                           [alt]="'user_profile.profile_picture' | translate"
                           (error)="onImageError()"/>
                      <a (click)="changePicture()" class="change-picture-link">
                        <span>{{'user_profile.click_to_change_pfp' | translate}}</span>
                      </a>
                    </div>
                    <p class="file-requirements text-muted mt-2 mb-0" style="font-size: 0.85rem;">
                      <i class="fa fa-info-circle mr-1"></i>
                      {{'user_profile.file_requirements' | translate}}
                    </p>
                    <input type="file"
                           id="file-input"
                           (change)="onSelectedPicture($event)"
                           accept="image/png,image/jpeg,image/jpg"
                           class="hidden-file-input">
                  </div>

                  <!-- Canvas cropper shown once file selected -->
                  <div *ngIf="selectedFile" class="cropper-section">
                    <div class="cropper-row">
                      <div class="cropper-col">
                        <h6>{{'user_profile.adjust_image' | translate}}</h6>
                        <div class="image-cropper-container">
                          <canvas #cropCanvas
                                  class="crop-canvas"
                                  (mousedown)="onCanvasMouseDown($event)"
                                  (mousemove)="onCanvasMouseMove($event)"
                                  (mouseup)="onCanvasMouseUp()"
                                  (mouseleave)="onCanvasMouseUp()"
                                  (touchstart)="onCanvasTouchStart($event)"
                                  (touchmove)="onCanvasTouchMove($event)"
                                  (touchend)="onCanvasTouchEnd()">
                          </canvas>
                        </div>
                      </div>
                      <div class="preview-col">
                        <h6>{{'user_profile.preview' | translate}}</h6>
                        <div class="preview-container">
                          <canvas #previewCanvas class="preview-canvas"></canvas>
                        </div>
                      </div>
                    </div>
                    <div class="button-group">
                      <button class="button button-submit"
                              type="button"
                              (click)="uploadPicture()"
                              [disabled]="submitting || !croppedImage">
                        {{ (submitting ? 'user_profile.uploading' : 'user_profile.upload') | translate }}
                        <span *ngIf="submitting">...</span>
                      </button>
                      <button class="button button-cancel"
                              type="button"
                              [disabled]="submitting"
                              (click)="onCancelImageChangedEvent()">
                        {{'common.cancel' | translate}}
                      </button>
                    </div>
                  </div>

                </ng-container>

                <ng-template #ssrPlaceholder>
                  <p style="height: 30px; text-align: center">
                    {{'common.loading' | translate}} ...
                  </p>
                </ng-template>

              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <app-sidebar [currentUser]="currentUser"></app-sidebar>
    </div>
  </div>
</div>